module.exports = __webpack_public_path__ + "static/img/r_4.36174370.png";